<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-table
        ref="substanceTable"
        title="구성성분 목록"
        tableId="substanceTable"
        :columns="grid.columns"
        :data="grid.data"
        :columnSetting="false"
        selection="multiple"
        rowKey="mdmMaterialSubstancesId"
        :filtering="false"
        :usePaging="false"
        :hideBottom="true"
        gridHeight="350px"
        @table-data-change="tableDataChange"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="환경부-화학물질정보 연동 추가" v-if="editable" icon="add" @btnClicked="addApiRow" />
            <c-btn label="추가" v-if="editable" icon="add" @btnClicked="addrow" />
            <c-btn label="삭제" v-if="editable" icon="remove" @btnClicked="removeRow" />
            <c-btn label="저장" v-if="editable" icon="save" @btnClicked="saveSubstance" />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props,col }">
          <template>
            <q-chip
              v-if="col.name==='msdslink' && props.row.mttrid != ''"
              color="blue"
              :clickable="true"
              @click.stop="() => msdslink(props.row)"
              text-color="white">
              MSDS
            </q-chip>
          </template>
        </template>
      </c-table>
    </div>
    <div class="col-md-12 col-lg-12">
      <c-table
        ref="innertable"
        tableId="innertable"
        title="구성성분별 규제사항"
        class="topcolor-orange"
        :columns="grid2.columns"
        :data="grid2.data"
        :columnSetting="false"
        :filtering="false"
        :usePaging="false"
        :hideBottom="true"
        :gridHeight="innertableHeight"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" v-if="editable" icon="save" @btnClicked="saveSubstanceRegs" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chem-components',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        plantCd: '',
        plantName: '',
        materialCd: '',
        materialName: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid2: {
        columns: [
        ],
        data: [],
      },
      grid: {
        columns: [],
        data: [],
      },
      searchParam: {
        useFlag: 'Y',
      },
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      innertableHeight: '',
      headerUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      mixFlagItems: [
        { code: 'Y', codeName: '혼합' },
        { code: 'N', codeName: '단일' },
      ],
      cmrFlagItems: [
        { code: '1A', codeName: '1A' },
        { code: '1B', codeName: '1B' },
        { code: '2', codeName: '2' },
      ],
      gradeItems: [
        { code: '4', codeName: '최대' },
        { code: '3', codeName: '대' },
        { code: '2', codeName: '중' },
        { code: '1', codeName: '소' },
      ],
      formItems: [
        { code: '분진', codeName: '분진(㎎/㎥)' },
        { code: '증기', codeName: '증기(ppm)' },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.headerUrl = selectConfig.mdm.mam.chem.header.url;
    this.getHeader();
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.innertableHeight = (window.innerHeight - 500) + 'px';
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.chem.substance.url;
      this.saveUrl = transactionConfig.mdm.mam.chem.substance.save.url;
      this.deleteUrl = transactionConfig.mdm.mam.chem.substance.delete.url;
      this.reglistUrl = selectConfig.mdm.mam.chem.substance.regulate.url;
      this.regsaveUrl = transactionConfig.mdm.mam.chem.regulate.save.url;
      this.tableHeaderSet();
      this.getDetail();
    },
    tableHeaderSet() {
      this.$comm.getComboItems('MALEFICENCE_TYPE').then(_result => {
        this.$comm.getComboItems('VOLUME_UNIT').then(_result2 => {
          this.$comm.getComboItems('CLOSED_VENTILATION').then(_result3 => {
            this.grid.columns = [
              {
                name: 'chemNmKr',
                field: 'chemNmKr',
                label: '화학물질명(KOR)',
                type: 'text',
                align: 'left',
                style: 'width:350px',
                sortable: false,
              },
              {
                name: 'casNo',
                field: 'casNo',
                label: 'CAS No.',
                align: 'center',
                style: 'width:120px',
                type: 'text',
                sortable: false,
              },
              {
                name: 'msdslink',
                field: 'msdslink',
                label: 'MSDS',
                type: 'custom',
                align: 'center',
                sortable: false,
                style: 'width:100px',
                helpcomment: '산업안전보건공단에서 제공하는 MSDS정보'
              },
              {
                name: 'molecularFormula',
                field: 'molecularFormula',
                label: '분자식',
                align: 'center',
                style: 'width:120px',
                type: 'text',
                sortable: false,
              },
              {
                label: '함유량(%)',
                align: 'center',
                child: [
                  // {
                  //   name: 'limitHigh',
                  //   field: 'limitHigh',
                  //   label: '상한',
                  //   align: 'center',
                  //   style: 'width:90px',
                  //   type: 'number',
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'limitLow',
                  //   field: 'limitLow',
                  //   label: '하한',
                  //   align: 'center',
                  //   style: 'width:90px',
                  //   type: 'number',
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'limitLabel',
                  //   field: 'limitLabel',
                  //   label: '표기',
                  //   align: 'center',
                  //   style: 'width:120px',
                  //   type: 'text',
                  //   sortable: false,
                  // },
                  {
                    name: 'limitRepval',
                    field: 'limitRepval',
                    label: '대표값',
                    align: 'center',
                    style: 'width:80px',
                    type: 'number',
                    sortable: false,
                  },
                ]
              },
              {
                name: 'businessSecFlag',
                field: 'businessSecFlag',
                label: '영업비밀',
                align: 'center',
                style: 'width:80px',
                sortable: false,
                type: 'check',
                true: 'Y',
                false: 'N'
              },
              {
                label: '화학물질 위험성평가용',
                align: 'center',
                child: [
                  {
                    name: 'col6',
                    field: 'col6',
                    label: '측정유무',
                    align: 'center',
                    style: 'width:80px',
                    type: 'check',
                    true: 'Y',
                    false: 'N',
                    sortable: false,
                  },
                  {
                    name: 'col8',
                    field: 'col8',
                    label: '유소견자유무',
                    align: 'center',
                    style: 'width:100px',
                    type: 'check',
                    true: 'Y',
                    false: 'N',
                    sortable: false,
                  },
                  {
                    name: 'maleficenceForm',
                    field: 'maleficenceForm',
                    label: '유해성<br>발생형태<br>(성상)',
                    align: 'center',
                    type: 'select',
                    style: 'width:100px',
                    comboItems: this.formItems,
                    sortable: false,
                  },
                  {
                    name: 'maleficenceValue',
                    field: 'maleficenceValue',
                    label: 'TWA측정값',
                    align: 'center',
                    type: 'number',
                    style: 'width:80px',
                    sortable: false,
                  },
                  // {
                  //   name: 'col7',
                  //   field: 'col7',
                  //   label: '성상',
                  //   align: 'center',
                  //   type: 'select',
                  //   style: 'width:100px',
                  //   comboItems: this.formItems,
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'col9',
                  //   field: 'col9',
                  //   label: 'TWA(ppm)값',
                  //   align: 'center',
                  //   type: 'text',
                  //   style: 'width:100px',
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'col10',
                  //   field: 'col10',
                  //   label: 'TWA(mg)값',
                  //   align: 'center',
                  //   type: 'text',
                  //   style: 'width:100px',
                  //   sortable: false,
                  // },
                  {
                    name: 'col11',
                    field: 'col11',
                    label: '측정(ppm)값',
                    align: 'center',
                    type: 'text',
                    style: 'width:100px',
                    sortable: false,
                  },
                  {
                    name: 'col12',
                    field: 'col12',
                    label: '측정(mg)값',
                    align: 'center',
                    type: 'text',
                    style: 'width:100px',
                    sortable: false,
                  },
                  {
                    name: 'col13',
                    field: 'col13',
                    label: 'R-Phrase값',
                    align: 'left',
                    type: 'text',
                    style: 'width:250px',
                    sortable: false,
                  },
                  // {
                  //   name: 'col14',
                  //   field: 'col14',
                  //   label: 'R-Phrase등급',
                  //   align: 'center',
                  //   type: 'text',
                  //   style: 'width:100px',
                  //   sortable: false,
                  // },
                  {
                    name: 'col15',
                    field: 'col15',
                    label: 'H-CODE값',
                    align: 'left',
                    type: 'text',
                    style: 'width:250px',
                    sortable: false,
                  },                  
                  {
                    name: 'hrCodeGrade',
                    field: 'hrCodeGrade',
                    label: '위험문구/<br>유해위험문구 등급',
                    align: 'center',
                    type: 'select',
                    style: 'width:80px',
                    comboItems: this.gradeItems,
                    sortable: false,
                  },
                  // {
                  //   name: 'col16',
                  //   field: 'col16',
                  //   label: 'H-CODE등급',
                  //   align: 'center',
                  //   type: 'text',
                  //   style: 'width:100px',
                  //   sortable: false,
                  // },
                  {
                    name: 'col17',
                    field: 'col17',
                    label: 'CMR_C값',
                    align: 'center',
                    type: 'select',
                    style: 'width:80px',
                    comboItems: this.cmrFlagItems,
                    sortable: false,
                  },
                  {
                    name: 'col18',
                    field: 'col18',
                    label: 'CMR_M값',
                    type: 'select',
                    style: 'width:80px',
                    comboItems: this.cmrFlagItems,
                    sortable: false,
                  },
                  {
                    name: 'col19',
                    field: 'col19',
                    label: 'CMR_R값',
                    type: 'select',
                    style: 'width:80px',
                    comboItems: this.cmrFlagItems,
                    sortable: false,
                  },
                  {
                    name: 'cmrFlag',
                    field: 'cmrFlag',
                    label: 'CMR 물질 여부',
                    align: 'center',
                    type: 'check',
                    true: 'Y',
                    false: 'N',
                    style: 'width:80px',
                    sortable: false,
                  },
                  {
                    name: 'col20',
                    field: 'col20',
                    label: '물질구분(단일/혼합)',
                    align: 'center',
                    type: 'select',
                    style: 'width:100px',
                    comboItems: this.mixFlagItems,
                    sortable: false,
                  },
                  {
                    name: 'col21',
                    field: 'col21',
                    label: '하루취급량',
                    align: 'right',
                    type: 'text',
                    style: 'width:100px',
                    sortable: false,
                  },
                  {
                    name: 'col22',
                    field: 'col22',
                    label: '하루취급량단위',
                    align: 'center',
                    type: 'select',
                    style: 'width:100px',
                    comboItems: _result2,
                    sortable: false,
                  },
                  // {
                  //   name: 'col24',
                  //   field: 'col24',
                  //   label: '비산성',
                  //   align: 'center',
                  //   type: 'select',
                  //   style: 'width:100px',
                  //   comboItems: _result,
                  //   sortable: false,
                  // },
                  {
                    name: 'maleficenceType',
                    field: 'maleficenceType',
                    label: '비산/휘발성구분',
                    align: 'center',
                    type: 'select',
                    style: 'width:100px',
                    comboItems: _result,
                    sortable: false,
                  },
                  {
                    name: 'maleficenceGrade',
                    field: 'maleficenceGrade',
                    label: '비산성 등급',
                    align: 'center',
                    type: 'select',
                    style: 'width:100px',
                    comboItems: this.gradeItems,
                    sortable: false,
                  },
                  {
                    name: 'col25',
                    field: 'col25',
                    label: '사용온도',
                    align: 'center',
                    type: 'text',
                    style: 'width:100px',
                    sortable: false,
                  },
                  {
                    name: 'boilingPoint',
                    field: 'boilingPoint',
                    label: '끓는점',
                    align: 'center',
                    type: 'number',
                    style: 'width:80px',
                    sortable: false,
                  },
                  {
                    name: 'col27',
                    field: 'col27',
                    label: '밀폐환기상태',
                    align: 'center',
                    type: 'select',
                    style: 'width:200px',
                    comboItems: _result3,
                    sortable: false,
                  },



                  // {
                  //   name: 'maleficenceType',
                  //   field: 'maleficenceType',
                  //   label: '비산/휘발성구분',
                  //   align: 'center',
                  //   type: 'select',
                  //   style: 'width:100px',
                  //   comboItems: _result,
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'maleficenceGrade',
                  //   field: 'maleficenceGrade',
                  //   label: '비산성 등급',
                  //   align: 'center',
                  //   type: 'select',
                  //   style: 'width:100px',
                  //   comboItems: [
                  //     { code: '4', codeName: '최대' },
                  //     { code: '3', codeName: '대' },
                  //     { code: '2', codeName: '중' },
                  //     { code: '1', codeName: '소' },
                  //   ],
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'hrCodeGrade',
                  //   field: 'hrCodeGrade',
                  //   label: '위험문구/<br>유해위험문구 등급',
                  //   align: 'center',
                  //   type: 'select',
                  //   style: 'width:80px',
                  //   comboItems: [
                  //     { code: '4', codeName: '최대' },
                  //     { code: '3', codeName: '대' },
                  //     { code: '2', codeName: '중' },
                  //     { code: '1', codeName: '소' },
                  //   ],
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'rcode',
                  //   field: 'rcode',
                  //   label: '위험문구(R-phrase)',
                  //   align: 'left',
                  //   type: 'text',
                  //   style: 'width:200px',
                  //   sortable: false,
                  // },
                  // {
                  //   name: 'hcode',
                  //   field: 'hcode',
                  //   label: '유해위험문구(H-code)',
                  //   align: 'left',
                  //   type: 'text',
                  //   style: 'width:200px',
                  //   sortable: false,
                  // },
                ]
              },
              // {
              //   label: '물질정보(PSM대상일 경우만 입력)',
              //   align: 'center',
              //   child: [
              //     {
              //       name: 'exposedBasis',
              //       field: 'exposedBasis',
              //       label: '노출기준',
              //       align: 'center',
              //       style: 'width:110px',
              //       type: 'text',
              //       sortable: false,
              //     },
              //     {
              //       name: 'exposedBasisUnitCd',
              //       field: 'exposedBasisUnitCd',
              //       label: '노출기준 단위',
              //       align: 'center',
              //       style: 'width:110px',
              //       sortable: false,
              //       type: 'select',
              //       comboItems: _result,
              //       setHeader: false,
              //     },
              //     {
              //       name: 'toxicity',
              //       field: 'toxicity',
              //       label: '독성치',
              //       align: 'center',
              //       style: 'width:120px',
              //       type: 'text',
              //       sortable: false,
              //     },
              //   ]
              // },
            ]
          });
        });
      });
    },
    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = 'GET';
      this.$http.param = {headerType: 'check'};
      this.$http.request((_result) => {
        let _items = {
          name: 'chemNmKr',
          field: 'chemNmKr',
          label: '화학물질명(KOR)',
          align: 'left',
          style: 'width:220px',
          sortable: false,
        }
        this.grid2.columns.push(_items);
        this.$_.forEach(_result.data, _item => {
          this.grid2.columns.push(_item);
        })
        this.getLaw();
      },);
    },
    getLaw() {
      this.$http.url = this.reglistUrl;
      this.$http.type = 'GET';
      this.$http.param = {mdmChemMaterialId: this.param.mdmChemMaterialId};
      this.$http.request((_result) => {
        this.grid2.data = _result.data;
      },);
    },
    getDetail() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {mdmChemMaterialId: this.param.mdmChemMaterialId};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    addrow() {
      // 초기에는 userId에 tempId를 부여
      this.grid.data.splice(0, 0, {
        editFlag: 'C',
        mdmChemMaterialId: this.param.mdmChemMaterialId,
        mdmMaterialSubstancesId: uid(),
        casNo: '',
        chemNmKr: '',
        chemNmEn: '',
        limitLabel: '',
        limitHigh: '',
        limitLow: '',
        limitRepval: '', // 대표값(함유량)
        businessSecFlag: 'N',
        molecularFormula: '',
        boilingPoint: null,  // 끓는점
        hrCodeGrade: null,
        maleficenceForm: null, // 성상
        maleficenceType: null,
        maleficenceValue: '', //TWA값
        mttrid: '',
        cmrFlag: 'N',
        rcode: '',  // 위험문구(R-code)
        hcode: '',  // 유해위험문구(H-code)
        regUserId: this.$store.getters.user.userId,
        col6: 'N',  // 측정유무
        col8: 'N',  // 유소견자유무
        col11: '',  // 측정(ppm)값
        col12: '',  // 측정(mg)값
        col13: '',  // R-Phrase값
        col14: '',  // R-Phrase등급
        col15: '',  // H-CODE값
        col16: '',  // H-CODE등급
        col17: null,  // CMR_C값
        col18: null,  // CMR_M값
        col19: null,  // CMR_R값
        col20: null,  // 물질구분(단일/혼합)
        col21: '',  // 하루취급량
        col22: null,  // 하루취급량단위
        col24: null,  // 비산성
        col25: '',  // 사용온도
        col27: null,  // 밀폐환기상태
      })
    },
    addApiRow() {
      this.popupOptions.target = () => import(`${'@/pages/common/openapi/materialApiPop.vue'}`);
      this.popupOptions.title = '환경부-화학물질정보 연동 검색';
      this.popupOptions.width = '50%';
      this.popupOptions.param = {
        type: 'multiple'
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    msdslink(row) {
      window.open('https://msds.kosha.or.kr/MSDSInfo/kcic/msdsdetail.do?chem_id='+row.mttrid+'&viewType=msds','msdspop','width=1280, height=768, menubar=no, status=no, toolbar=no');
    },
    closePopup(_data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if(_data.length !== undefined) {
        this.$_.forEach(_data, item => {
          if (this.$_.findIndex(this.grid.data, { casNo: item.casno }) === -1) {
            this.grid.data.splice(0, 0, {
              editFlag: 'C',
              mdmChemMaterialId: this.param.mdmChemMaterialId,
              mdmMaterialSubstancesId: uid(),
              casNo: item.casno ? item.casno : '',
              chemNmKr: item.mttrnmkor ? item.mttrnmkor : '',
              chemNmEn: item.mttrnmeng ? item.mttrnmeng : '',
              limitLabel: '',
              limitHigh: '',
              limitLow: '',
              limitRepval: '',
              businessSecFlag: 'N',
              cmrFlag: 'N',
              boilingPoint: null,
              hrCodeGrade: null,
              maleficenceForm: null,
              maleficenceType: null,
              maleficenceValue: '',
              molecularFormula: item.molecform ? item.molecform : '',
              mttrid: item.chemId ? item.chemId : '',  // 환경부데이터 물질ID(CHEM ID)
              regUserId: this.$store.getters.user.userId,
              col6: 'N',  // 측정유무
              col8: 'N',  // 유소견자유무
              col7: null,  // 성상
              col9: '',  // TWA(ppm)값
              col10: '',  // TWA(mg)값
              col11: '',  // 측정(ppm)값
              col12: '',  // 측정(mg)값
              col13: '',  // R-Phrase값
              col14: '',  // R-Phrase등급
              col15: '',  // H-CODE값
              col16: '',  // H-CODE등급
              col17: null,  // CMR_C값
              col18: null,  // CMR_M값
              col19: null,  // CMR_R값
              col20: null,  // 물질구분(단일/혼합)
              col21: '',  // 하루취급량
              col22: null,  // 하루취급량단위
              col24: null,  // 비산성
              col25: '',  // 사용온도
              col26: '',  // 끓는점
              col27: null,  // 밀폐환기상태
            })
          }
        })
      }
    },
    saveSubstance() {
      let checkItem = ['chemNmKr']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [화학물질명]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('APP_REQUEST_SUCCESS');
                this.getDetail();
                this.getLaw();
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removeRow() {
      let selectData = this.$refs['substanceTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getDetail();
              this.getLaw();
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, item);
              })
              this.$refs['substanceTable'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveSubstanceRegs() {
      let saveData = this.grid2.data.filter( x => {
        return x.editFlag == 'U'
      });
      this.$_.forEach(saveData, item => {
        item.regUserId = this.$store.getters.user.userId;
        item.chgUserId = this.$store.getters.user.userId;
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.regsaveUrl;
            this.$http.type = 'POST';
            this.$http.param = saveData;
            this.$http.request(() => {
              this.getLaw();
              this.$emit('updateChemInfo')
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '저장되었습니다.', /* 저장되었습니다. */
                type: 'success', // success / info / warning / error
              });
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    },
    tableDataChange(props, col) {
      // CRM 물질여부 체크
      if (col.name === 'col17' || col.name === 'col18' || col.name === 'col19') {
        if (props.row['col17'] === '1A' || props.row['col17'] === '1B' || props.row['col17'] === '2' || props.row['col18'] === '1A' || props.row['col18'] === '1B' || props.row['col18'] === '2' || props.row['col19'] === '1A' || props.row['col19'] === '1B' || props.row['col19'] === '2') {
          this.$set(props.row, 'cmrFlag', 'Y')
        } else {
          this.$set(props.row, 'cmrFlag', 'N')
        }
      }
      // 유해위험문구 등급
      if (col.name === 'col13' || col.name === 'col15') {
        let grade4 = 'R40,R42,R42/43,R45,R46,R49,H340,H341,H350,H334,R26,R26/27,R26/27/28,R26/28,R27,R27/28,R28,R40,R48/23,R48/23/24,R48/23/24/25,R48/23/25,R48/24,R48/24/25,R48/25,R60,R61,R62,R63,H300,H310,H330,H304,H370,H372,H351,H360,H361';
        let grade3 = 'R23,R23/24,R23/24/25,R23/25,R24,R24/25,R25,R34,R35,R36/37,R36/37/38,R37,R37/38,R41,R43,R48/20,R48/20/21,R48/20/21/22,R48/20/22,R48/21,R48/21/22,R48/22,H301,H311,H331,H314,H318,H371,H373,H335,H317';
        let grade2 = 'R20,R20/21,R20/21/22,R20/22,R21,R21/22,R22,H302,H312,H332,H305';

        let gradearr4 = grade4.split(',');
        let gradearr3 = grade3.split(',');
        let gradearr2 = grade2.split(',');
        let isGrade = false;
        let strcol13 = '';
        let strcol15 = '';
        if (props.row['col13'] !== null) {
          strcol13 = props.row['col13']
        }
        if (props.row['col15'] !== null) {
          strcol15 = props.row['col15']
        }
        let col13arr = strcol13.split(',');
        let col15arr = strcol15.split(',');

        this.$_.forEach(gradearr4, item => {
          if (!isGrade) {
            if (col13arr.indexOf(item) > -1) {
              this.$set(props.row, 'hrCodeGrade', '4')
              isGrade = true;
            }
            if (col15arr.indexOf(item) > -1) {
              this.$set(props.row, 'hrCodeGrade', '4')
              isGrade = true;
            }
          }
        });
        if (!isGrade) {
          if (!isGrade) {
            this.$_.forEach(gradearr3, item => {
              if (col13arr.indexOf(item) > -1) {
                this.$set(props.row, 'hrCodeGrade', '3')
                isGrade = true;
              }
              if (col15arr.indexOf(item) > -1) {
                this.$set(props.row, 'hrCodeGrade', '3')
                isGrade = true;
              }
            });
          }
        }
        if (!isGrade) {
          if (!isGrade) {
            this.$_.forEach(gradearr2, item => {
              if (col15arr.indexOf(item) > -1) {
                this.$set(props.row, 'hrCodeGrade', '2')
                isGrade = true;
              }
              if (col15arr.indexOf(item) > -1) {
                this.$set(props.row, 'hrCodeGrade', '2')
                isGrade = true;
              }
            });
          }
        }
        if (!isGrade) {
          this.$set(props.row, 'hrCodeGrade', '1')
        }
      }
    },
  }
};
</script>